import React from 'react';

import thunderIcon from '../../../../assets/icons/pass/thunder.svg';
import DateRange from '../../../../shared/components/DateRange';

const CalendarIcon: React.FC = () => (
    <svg
        width="10"
        height="10"
        viewBox="0 0 24 24"
        fill="none"
        stroke="rgba(0,43,102,0.70)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="block shrink-0"
    >
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
);

export interface PassHeaderProps {
    title: string;
    dateRange?: string;
    startDate?: string | null;
    endDate?: string | null;
    price: string | number;
    originalPrice?: string | null;
    isActive?: boolean;
}

const PassHeader: React.FC<PassHeaderProps> = ({
    title,
    dateRange,
    startDate,
    endDate,
    price,
    originalPrice,
}) => {
    return (
        <div className="w-full flex flex-row items-start justify-between gap-6 md:gap-0">
            <div className="flex flex-col items-start gap-[6px] md:gap-1">
                <h3 className="font-['Noto_Sans'] text-[22px] font-semibold leading-[32px] text-[#002B66] m-0 tracking-[0px] w-[150px] md:w-auto">
                    {title}
                </h3>
                <div className="flex items-center gap-1.5 font-['Noto_Sans'] text-[12px] font-normal leading-[18px] text-[rgba(0,43,102,0.70)] m-0 tracking-[0px]">
                    <CalendarIcon />
                    {startDate ? (
                        <DateRange
                            startDate={startDate}
                            endDate={endDate}
                            format="long"
                            className="font-['Noto_Sans'] text-[12px] font-normal leading-[18px] text-[rgba(0,43,102,0.70)] m-0"
                        />
                    ) : (
                        <span className="font-['Noto_Sans'] text-[12px] font-normal leading-[18px] text-[rgba(0,43,102,0.70)] m-0">
                            {dateRange}
                        </span>
                    )}
                </div>
            </div>

            <div className="flex flex-col items-end">
                <div className="flex items-center gap-1.5">
                    <img src={thunderIcon} alt="thunder" className="w-[20px] h-[20px]" />
                    <span className="font-['Noto_Sans'] text-[18px] font-semibold leading-[26px] text-[#002B66] m-0 tracking-[0px]">
                        {price !== 'N/A' ? price : '$0.00'}
                    </span>
                </div>
                {originalPrice && (
                    <div className="font-['Noto_Sans'] text-[12px] font-normal leading-[18px] text-[#667085] line-through m-0 tracking-[0px] mr-[2px] mt-[2px]">
                        {originalPrice}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PassHeader;
